export default __webpack_public_path__ + "static/media/p2.e25642f2.jpg";